
<style scoped>

  .navbar-brand {
    float: none;
    /* padding: 15px 15px; */
    font-size: 18px;
    line-height: 20px;
    max-height: 60px;
  }


  .p-button {
    color: #ffffff;
    background: #ff9800;
    border: 1px solid #ff9800;
    padding: 0.75rem 1.25rem;
    font-size: 1rem;
    transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
    border-radius: 6px;
  }

      .p-button:hover {
        color: white;
        background: lightgrey;
        border: 1px solid lightgrey;
        padding: 0.75rem 1.25rem;
        font-size: 1rem;
        transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
        border-radius: 6px;
      }


    ul.stepper .step.active:before {
        background-color: #ff9800 !important;
    }

    .modal-dialog-full-width {
        width: 100% !important;
        height: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
        max-width: none !important;
    }

    .modal-content-full-width {
        height: auto !important;
        min-height: 100% !important;
        border-radius: 0 !important;
        background-color: #ececec !important
    }

    .modal-header-full-width {
        border-bottom: 1px solid #9ea2a2 !important;
    }

    .modal-footer-full-width {
        border-top: 1px solid #9ea2a2 !important;
    }

    .sec-heading {
        margin-bottom: 25px !important;
    }

    .section {
        padding-top: 160px;
        padding-bottom: 25px !important; 
    }

    .pricing-table .card {
  -webkit-transition: all 0.2s;
  -o-transition: all 0.2s;
  transition: all 0.2s;
  -webkit-border-radius: 15px;
  border-radius: 15px; }
  .pricing-table .card .card-title {
    font-size: 1rem;
    letter-spacing: .2rem;
    font-weight: 500; }
  .pricing-table .card .card-price {
    font-size: 2.7rem; }
    .pricing-table .card .card-price .term {
      font-size: .875rem; }
  .pricing-table .card .fa-ul li:not(:last-child) {
    margin-bottom: 1rem; }

@media (min-width: 992px) {
  .pricing-table .card:hover {
    margin-top: -.25rem;
    margin-bottom: .25rem;
    -webkit-box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.3);
    box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.3); } }
</style>
<template>
  <div id="home" class="kenburn-hero">
    <div class="kenburn-slider">
      <!-- Heading -->
      <div class="hero-wrapper">
        <div class="hero-content">
          <h1 class="lead-white-bg wow slideInLeft" data-wow-duration="2s">
            <span>Discover</span><br>
            <span>Develop</span><br>
            <span>Deploy</span>
          </h1>
          <h4>We exist to Discover, Develop, and Deploy the leader in you</h4>
          <a href="#services" class="btn-ghost-light scroll">Learn More</a>
        </div>
      </div><!-- / .hero-wrapper -->
      <!-- Ken Burns Slider -->
      <canvas class="kenburns">
        <p>Your browser doesn't support canvas!</p>
      </canvas>
    </div><!-- / .kenburn-slider -->
    <!-- Scroller -->
    <a href="#services" class="scroller scroll" data-bs-target="#services">
      <span class="scroller-text">scroll down</span>
      <span class="linea-basic-magic-mouse"></span>
    </a>
  </div><!-- / #home .kenbrun-hero-->
  <!-- ========== Services ========== -->
  <div class="preloader">
    <img src="/images/loader.svg" alt="Loading...">
  </div>

  <div class="row">
    <div class="container my-5 py-5 z-depth-1">
      <!--Section: Content-->
      <section class="text-center">
        <!-- Section heading -->
        <h3 class="font-weight-bold mb-5"> <span class="badge badge-orange text-white mb-5 mr-2" style="background-color: #1d4f91">Get Yours Today</span>Dream. Desire. Decide. <span class="badge badge-orange text-white mb-5 mr-2" style="background-color: #E65100">New!</span></h3>
        <div class="row">
          <div class="col-lg-6">
            <!--Carousel Wrapper-->
            <div id="carousel-thumb1" class="carousel slide carousel-fade carousel-thumbnails mb-5 pb-4" data-ride="carousel">
              <!--Slides-->
              <div class="carousel-inner text-center text-md-left" role="listbox">
                <div class="carousel-item active">
                  <img src="https://shop.martinwilliams.org/cdn/shop/files/PNGimage.jpg?v=1694323985&width=360"
                       alt="First slide" class="img-fluid">
                </div>

              </div>
              <!--/.Slides-->
              <!--Thumbnails-->
              <a class="carousel-control-prev" href="#carousel-thumb1" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
              </a>
              <a class="carousel-control-next" href="#carousel-thumb1" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
              </a>
              <!--/.Thumbnails-->
            </div>
            <!--/.Carousel Wrapper-->
          </div>
          <div class="col-lg-5 text-center text-md-left">
            <h2 class="h2-responsive text-center text-md-left product-name font-weight-bold dark-grey-text mb-1 ml-xl-0 ml-4">Now Available</h2>

            <h3 class="h3-responsive text-center text-md-left mb-5 ml-xl-0 ml-4">
              <span class="red-text font-weight-bold">
                <strong>$20</strong>
              </span>
              <span class="grey-text">
                <small>
                  <s>$45</s>
                </small>
              </span>
            </h3>
            <div class="font-weight-normal">
              <p class="ml-xl-0 ml-4">Dr Martin Williams unpacks the art of identifying, harnessing and elevating your dreams functionally to invoke your desires to becoming a reality.  In this book you will learn the methods to discovering and unlocking your purpose. You will learn how to navigate your desires by making the decision to implement and govern your life based on your dreams unlocking permanent fulfillment in your life. Take the initial step and invest in yourself now and purchase your copy by clicking below. </p>
              <div class="mt-5">
                <div class="row mt-3 mb-4">
                  <div class="col-md-12 text-center text-md-left text-md-right">
                    <a class="btn btn-primary btn-rounded" href="https://shop.martinwilliams.org/products/dream-desire-decide" target="_blank">
                      <i class="fas fa-cart-plus mr-2" aria-hidden="true"></i> Order Now
                    </a>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </section>
    </div>
  </div>

  <div id="about" class="gray-bg">
    <section class="container section team-3col">
      <header class="sec-heading">
        <h2>Meet Our Founders</h2>
        <span class="subheading">
          MWI exists to encourage individuals and organizations to build strong networks that aid others in their endeavors. Our vision is to empower and equip leaders through training, modeling, and networking. We strive to produce quality leaders with personal integrity and strong character in order to become agents of change in our society.
        </span>
      </header>


      <div class="row">
        <!-- Member 1 -->
        <div class="col-lg-6 col-sm-12 mb-sm-50 m-sm-0 text-center">
          <div class="t-item wow fadeIn card d-flex justify-content-md-center" data-wow-duration="1s">
            <!-- Image -->
            <div class="t-image">
              <img src="/images/Pm.png" alt="Founder" class="img-responsive img-fluid">
              <div class="t-description">
                <div class="content-wrapper">
                  <p>
                    Dr. Martin Williams is a catalyst that ignites leaders by challenging mindsets. His academic attainment includes a Masters in Leisure Sports Management and a Doctorate in Biblical Studies. Dr. Williams served as CEO and Founder of Ambassadors Worship Center, a thriving multi-cultural assembly of leaders for over 28 years.  He is the Founder of Martin Williams International, a nonprofit organization dedicated to the development of individuals. Dr. Williams is also established in several other ventures such as Dream Realty, The Carver Legacy Center, The DreamMakers Foundation, & various other social endeavors. Dr. Williams� principles have helped thousands find clarity in their assignments, develop mastery, & prosper in their God-given purpose.
                  </p>
                </div>
              </div>
            </div>
            <!-- Info -->
            <div class="t-info">
              <h4 class="t-name">Dr. Martin Williams</h4>
              <span class="t-role">CEO &amp; Founder</span>
              <ul class="social-links">
                <li><a href="https://www.facebook.com/MartinWilliamsInternational"><i class="fa-brands fa fa-facebook"></i></a></li>
                <li><a href="https://www.linkedin.com/in/martin-williams-673ab8128"><i class="fa-brands fa fa-instagram"></i></a></li>
                <li><a href="https://www.youtube.com/c/MartinWilliams"><i class="fa-brands fa fa-youtube"></i></a></li>
                <li><a href="https://www.twitter.com/DrMartinW"><i class="fa-brands fa fa-twitter"></i></a></li>
                <li><a href="https://www.linkedin.com/in/martin-williams-673ab8128/"><i class="fa-brands fa fa-linkedin"></i></a></li>
              </ul>
            </div>

          </div><!-- / .t-item -->
        </div><!-- / .col-md-4 -->

        <div class="col-lg-6 col-sm-12  mb-sm-50 text-center m-sm-0">
          <div class="t-item wow fadeIn card" data-wow-duration="1s" data-wow-delay=".3s">
            <div class="t-image">
              <img src="/images/Plnb.png" alt="Team Member" class="img-responsive img-fluid">
              <div class="t-description">
                <div class="content-wrapper">
                  <p>
                    Dr. Lynnell Williams, alongside Dr. Martin L. Williams, served as Executive Pastor of Ambassadors Worship Center located in Omaha, Nebraska from 1994 to 2022. In 1988, she completed her undergraduate studies at the University of Southern Mississippi with a degree in Fashion/Interior Design with an emphasis in Marketing. She also obtained her Doctor of Biblical Studies from Justice Fellowship International. Dr. Lynnell has a global influence in both ministry and prophetic singing. Her passion is to encourage believers to walk in excellence and be governed by the set lines of spiritual authority.
                    .
                  </p>
                </div>
              </div>
            </div>
            <div class="t-info">
              <h4 class="t-name">Dr. Lynnell Williams</h4>
              <span class="t-role">Co-founder</span>
              <ul class="social-links">
                <li><a href="https://www.facebook.com/MartinWilliamsInternational"><i class="fa-brands fa fa-facebook"></i></a></li>
                <li><a href="https://www.linkedin.com/in/martin-williams-673ab8128"><i class="fa-brands fa fa-instagram"></i></a></li>
                <li><a href="https://www.youtube.com/c/MartinWilliams"><i class="fa-brands fa fa-youtube"></i></a></li>
                <li><a href="https://www.twitter.com/DrMartinW"><i class="fa-brands fa fa-twitter"></i></a></li>
                <li><a href="https://www.linkedin.com/in/martin-williams-673ab8128/"><i class="fa-brands fa fa-linkedin"></i></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <section class="container section">
    <header class="sec-heading">
      <h2>What we do</h2>
      <span class="subheading">Learn about the Martin Williams International Network of Services</span>
    </header>
    <div class="row">
      <!-- Item 1 -->
      <div class="col-md-4 col-sm-12 mt-md-4" data-wow-duration=".6s" data-wow-delay=".3s">
        <div class="card card-cascade narrower">
          <!--Card image-->
          <div class="view view-cascade overlay">
            <img src="/images/gln.jpg" class="card-img-top"
                 alt="narrower">
            <a>
              <div class="mask rgba-white-slight"></div>
            </a>
          </div>
          <!--/.Card image-->
          <!--Card content-->
          <div class="card-body card-body-cascade">
            <a class="btn btn" style="width: 100%; background-color: #f18c18" data-toggle="modal" data-target="#exampleModalPreview">Learn More</a>
          </div>
          <!--/.Card content-->
        </div>
        <!--/.Card Narrower-->
      </div>
      <div class="col-md-4 col-sm-12 mt-4" data-wow-duration=".6s" data-wow-delay=".3s">
        <div class="card card-cascade narrower">
          <!--Card image-->
          <div class="view view-cascade overlay">
            <img src="/images/db.jpg" class="card-img-top"
                 alt="narrower">
            <a>
              <div class="mask rgba-white-slight"></div>
            </a>
          </div>
          <!--/.Card image-->
          <!--Card content-->
          <div class="card-body card-body-cascade">
            <a class="btn btn" href="https://www.dreambusiness.me/" target="_blank" style="width: 100%; background-color: #f18c18">Learn More</a>
          </div>
          <!--/.Card content-->
        </div>
      </div>
      <div class="col-md-4 col-sm-12 mt-4" data-wow-duration=".6s" data-wow-delay=".3s">
        <div class="card card-cascade narrower">
          <!--Card image-->
          <div class="view view-cascade overlay">
            <img src="/images/dreamreality.jpg" class="card-img-top"
                 alt="narrower">
            <a>
              <div class="mask rgba-white-slight"></div>
            </a>
          </div>
          <!--/.Card image-->
          <!--Card content-->
          <div class="card-body card-body-cascade">
            <a class="btn btn" href="https://www.dreamrealtypros.com/" target="_blank" style="width: 100%; background-color: #f18c18">Learn More</a>
          </div>
          <!--/.Card content-->
        </div>
      </div>
      <!--Test-->

      <div class="col-md-4 col-sm-12 mt-4" data-wow-duration=".6s" data-wow-delay=".3s">
        <div class="card card-cascade narrower">
          <!--Card image-->
          <div class="view view-cascade overlay">
            <img src="/images/legofw.jpg" class="card-img-top"
                 alt="narrower">
            <a>
              <div class="mask rgba-white-slight"></div>
            </a>
          </div>
          <!--/.Card image-->
          <!--Card content-->
          <div class="card-body card-body-cascade">
            <a class="btn btn" style="width: 100%; background-color: #f18c18" data-toggle="modal" data-target="#centralModalInfo">Learn More</a>
          </div>
          <!--/.Card content-->
        </div>
      </div>
      <div class="col-md-4 col-sm-12  mt-4" data-wow-duration=".6s" data-wow-delay=".3s">
        <div class="card card-cascade narrower">
          <!--Card image-->
          <div class="view view-cascade overlay">
            <img src="/images/blacklogoawc.jpg" class="card-img-top" alt="narrower" style="max-height:270px;">
            <a>
              <div class="mask rgba-white-slight"></div>
            </a>
          </div>
          <!--/.Card image-->
          <!--Card content-->
          <div class="card-body card-body-cascade">
            <a class="btn btn" href="https://awcchurch.org/" style="width: 100%; background-color: #f18c18" target="_blank">Learn More</a>
          </div>
          <!--/.Card content-->
        </div>
      </div>
      <div class="col-md-4 col-sm-12 mt-4" data-wow-duration=".6s" data-wow-delay=".3s">
        <div class="card card-cascade narrower">
          <!--Card image-->
          <div class="view view-cascade overlay">
            <img src="/images/legacyofwealth.jpg" class="card-img-top" alt="narrower">
            <a>
              <div class="mask rgba-white-slight"></div>
            </a>
          </div>
          <!--/.Card image-->
          <!--Card content-->
          <div class="card-body card-body-cascade">
            <a class="btn btn" href="#" style="width: 100%; background-color: #f18c18" data-toggle="modal" data-target="#centralModalDark">Learn More</a>
          </div>
          <!--/.Card content-->
        </div>
      </div>
      <div class="col-md-8 col-sm-12 h-100 mt-4" data-wow-duration=".6s" data-wow-delay=".3s">
        <div class="card card-cascade narrower" style="background-color:white">
          <!--Card image-->
          <div class="view view-cascade overlay" style="background-color:white;">
            <img src="https://mlmakv30gpqs.i.optimole.com/9Mk4rFs-rqVMFnOl/w:676/h:141/q:mauto/https://www.carverlegacycenter.com/wp-content/uploads/2022/03/cropped-cropped-Carver-Legacy-Logo-Horizontal-RGB-6.png" class="card-img-top mb-5" alt="narrower" style="height:180px">
            <a>
              <div class="mask rgba-white-slight"></div>
            </a>
          </div>
          <!--/.Card image-->
          <!--Card content-->
          <div class="card-body card-body-cascade">
            <a class="btn btn-outline" href="https://www.carverlegacycenter.com/" target="_blank" style="width: 100%; background-color: #f18c18">Learn More</a>
          </div>
          <!--/.Card content-->
        </div>
      </div>
      <div class="col-md-4 col-sm-12 mt-4" data-wow-duration=".6s" data-wow-delay=".3s">
        <div class="card card-cascade narrower">
          <!--Card image-->
          <div class="view view-cascade overlay">
            <img src="/images/Dk.jpg" class="card-img-top"
                 alt="narrower" style="height:213px">
            <a>
              <div class="mask rgba-white-slight"></div>
            </a>
          </div>
          <!--/.Card image-->
          <!--Card content-->
          <div class="card-body card-body-cascade">
            <a class="btn btn" href="https://www.dreamkeepers.me/" target="_blank" style="width: 100%; background-color: #f18c18">Learn More</a>
          </div>
          <!--/.Card content-->
        </div>
      </div>

    </div><!-- / .row -->
  </section>
  <div id="powertools">
    <section class="text-center container section">
      <header class="sec-heading">
        <h2><img src="https://mwiassets.blob.core.windows.net/logos/power-tools-assesment-2.png" height="175" /></h2>
        <span class="subheading" style="color:black">
          Understanding your strengths gives you power, influence  and helps promote greater performance in all areas of your life.
        </span>
      </header>

      <div class="row mt-3">
        <div class="col-12">
          <Card>
            <template #content>
              <h5>How It Works</h5>
              <Timeline :value="events1" align="alternate" class="customized-timeline">
                <template #marker="slotProps">
                    <i :class="slotProps.item.icon" style="font-size:2.5rem"></i>
                </template>
                <template #content="slotProps">
                  <Card>
                    <template #title>
                      {{slotProps.item.status}}
                      <label v-if="slotProps.item.status == 'Take The Power Tools Assessment'">&#8482;</label>
                    </template>
                    <template #subtitle>
                    </template>
                    <template #content>
                      <img v-if="slotProps.item.image" src="https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png" :alt="slotProps.item.name" width="200" class="shadow-2" />
                      <p class="subheading" style="font-family: 'Roboto', sans-serif;">
                        {{slotProps.item.Summary}}
                      </p>
                    </template>
                  </Card>
                </template>
              </Timeline>
            </template>
            <template #footer>
              <div class="row">
                <div class="col-6">
                  <Button icon="pi pi-search" label="Find My Assessment" class="w-full" iconPos="right" style="background-color: black; border-color:black" @click="FindAssessment" />
                </div>
                <div class="col-6">
                  <Button icon="pi pi-credit-card" label="Purchase" class="w-full" iconPos="right" style="background-color: orangered; border-color:orangered"  @click="PurchaseAssessment"/>
                </div>
                <!--<div class="col-6">
    <Button icon="pi pi-chevron-circle-right" label="Take Assessment" class="w-full" iconPos="right" style="background-color: #f18c18" @click="BeginAssessment" />
  </div>-->
              </div>
            </template>
          </Card>
        </div>
      </div>
    </section>
  </div>
  <!-- Scrollspy -->
  <div class="dotted-scrollspy">
    <ul class="nav smooth-scroll clearfix d-none d-sm-flex flex-column">
      <li class="nav-item"><a class="nav-link" href="#one"><span></span></a></li>
      <li class="nav-item"><a class="nav-link" href="#two"><span></span></a></li>
      <li class="nav-item"><a class="nav-link" href="#three"><span></span></a></li>
      <li class="nav-item"><a class="nav-link" href="#four"><span></span></a></li>
    </ul>
  </div>

  <section id="events" class="gray-bg">
    <div class="blog-home2 py-5">
      <div class="container">
        <!-- Row  -->
        <div class="row justify-content-center">
          <!-- Column -->
          <div class="col-md-8 text-center">
            <h3 class="my-3">Upcoming Events</h3>
            <h6 class="subtitle font-weight-normal">Register for one of our upcoming events</h6>
          </div>
          <!-- Column -->
          <!-- Column -->
        </div>
        <div class="row mt-4">
          <!--<div class="col-md-12">
            <div class="card border-0 mb-4 mt-2">
              <img class="z-depth-3" src="/images/stn2024new.jpg" alt="Shake The Nations 2024" style="max-height:55%">
              <a href="https://martinwilliamsinternational.brushfire.com/shakethenations2024/576099" class="btn btn-orange btn-block btn-rounded btn-lg mt-5">Register Now!</a>
            </div>
          </div>-->

          <div class="col-md-12">
            <Message severity="contrast" :closable="false">No Upcoming Events</Message>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="modal fade right" id="exampleModalPreview" tabindex="-1" role="dialog" aria-labelledby="exampleModalPreviewLabel" aria-hidden="true">
    <div class="modal-dialog-full-width modal-dialog momodel modal-fluid" role="document">
      <div class="modal-content-full-width modal-content ">
        <div class=" modal-header-full-width   modal-header text-center">
          <h5 class="modal-title w-100" id="exampleModalPreviewLabel">Martin Williams International</h5>
          <button type="button" class="close " data-dismiss="modal" aria-label="Close">
            <span style="font-size: 1.3em;" aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">

          <h1 class="section-heading text-center wow fadeIn my-5 pt-3"> About The Gloabl Leadership Network</h1>
          <div class="container my-5">
            <!--Section: Content-->
            <section class="dark-grey-text">
              <div class="row pr-lg-5">
                <div class="col-md-4 mb-4">

                  <div class="view">
                    <img src="/images/gln.jpg" class="img-fluid" alt="smaple image">
                  </div>
                </div>
                <div class="col-md-8 d-flex align-items-center">
                  <div>
                    <h3 class="font-weight-bold mb-2 mt-4">Our Mission</h3>
                    <p>The world is filled with competent leadership in every sphere and at every level. This leadership excellence is created on purpose, by design, and according to a prescribed pattern.</p>
                    <h3 class="font-weight-bold mb-2 mt-4">Our Vision</h3>
                    <ul class="list-group list-group-flush">
                      <li class="list-group-item">To develop a systematically impactful program that focuses on empowering individuals in personal and professional development areas through imparting wisdom, understanding, and knowledge to enhance their character, integrity, and personal leadership.</li>
                      <li class="list-group-item">GLN exists for the sole purpose of providing oversight through relationships to leaders, related ministries, para-organizations, and church ministers to fulfill their specific assignment.</li>
                      <li class="list-group-item">GLN has the church of the Lord Jesus Christ at its heart. Connecting to pastors and training pastors who have a desire to build Kingdom Cultures is GLNs primary goal.</li>
                    </ul>

                  </div>
                </div>
              </div>
              <div class="row pr-lg-5">
                <div class="col-md-12 d-flex align-items-center">
                  <div>
                    <h3 class="font-weight-bold mb-2 mt-4">The 5 C's</h3>
                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                      <li class="nav-item">
                        <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home"
                           aria-selected="true">Calling</a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile"
                           aria-selected="false">Clarity</a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact"
                           aria-selected="false">COMMUNICATION</a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" id="comm-tab" data-toggle="tab" href="#comm" role="tab" aria-controls="comm"
                           aria-selected="false">COMMITMENT</a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" id="cont-tab" data-toggle="tab" href="#cont" role="tab" aria-controls="cont"
                           aria-selected="false">CONTRIBUTION</a>
                      </li>
                    </ul>
                    <div class="tab-content" id="myTabContent">
                      <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                        Your calling can be thought of as the urge to share your gifts with the world. When you express your gifts for the sake of others, you often experience the joy of being fully alive. Gifts are more than just talents; they are what make you feel fulfilled and happy. You do not need to quit your &ldquo;day job&rdquo; &#8211; pursuing meaningful work may simply mean integrating your gifts and passions into the job you currently have. It is crucial that you have recognized and accepted the &ldquo;call&rdquo; on your life!
                      </div>
                      <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                        Have you ever experienced foggy weather? Low visibility and the inability to see what you know exists leaves you feeling lost in the once-familiar, now misty world around you? Are you sure and clear regarding the vision and mission of Global Leaders Network (GLN)? Sometimes we need help understanding ourselves in order to tune in to our true god-given purpose. With the proper help, you can delve into your innermost being, identifying your deep values and ambitions to bring greater clarity and meaning into your life. By learning to access deeper and intuitive sources of guidance you will receive a stronger and surer sense of clarity in your life to guide you towards your goals. Discussing your goals and guidelines for a happy life with someone else can help you reflect on your choices and evaluate whether they are crucial and beneficial.
                      </div>
                      <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                        Effective partnering requires a culture of continual collaboration and communication! Good communication is an important part of all relationships and is an essential part of any healthy partnership. Effectively communicating ensures that you not only convey your message to someone but also let them know about your personal feelings and emotions. Communication can best be summarized as the transmission of a message from a sender to a receiver in an understandable manner. Effective communication leads to mutual understanding.
                      </div>

                      <div class="tab-pane fade" id="comm" role="tabpanel" aria-labelledby="comm-tab">
                        The stronger your commitment, the more likely you are to succeed as you refuse to give up or give in. You make more disciplined and productive decisions  &#8211; and are more willing to go out of your comfort zone. That's what it takes to achieve success. A committed relationship is an interpersonal relationship based upon agreed-upon commitment to one another involving love, trust, honesty, openness, etc. Are you willing to further the vision and mission of GLN and the advancing of the Kingdom Message? Commitment is also about compromises and learning the art of agreeing despite conflicts. Real commitment enables partners to build the necessary trust to deliver value on current and future initiatives together!

                      </div>
                      <div class="tab-pane fade" id="cont" role="tabpanel" aria-labelledby="cont-tab">
                        Contribution can have different meanings in different context. In connecting with our network, a partner is expected to share and bring resources and financial donations in advancing the organization. Being a partner of the network offers many benefits and the opportunity for personal/ministry growth and development, and these opportunities are paired with expectations that all partners will actively contribute to the activities of the network and uphold high standards, core values, and its ideas. Fees and monthly financial donations are discussed and set according to level in which an individual chooses to join the organization. Your trust and commitment to financially invest into GLN will ensure its&#8218; vision and mission will be expanded across the world!
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <!--Section: Content-->
          </div>
        </div>
        <div class="modal-footer-full-width  modal-footer">
          <button type="button" class="btn btn-orange btn-md btn-rounded" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
  <div id="partner">
    <section class="container section team-3col" style="padding-top:40px">
      <header class="sec-heading">
        <h2>Partner With Us And <b style="color: #f1881a">Make A Global Impact</b></h2>
        <span class="subheading">
          With the help of our partners we continue our dedication to the cause of developing others into the full potential of what they were created and placed on Earth to be. We accomplish our/this mission through various resources and opportunities from annual international conferences, to traveling the world impact nations, and even through one-on-one coaching and mentorship. Our partners empower the change we want to see in our world.
        </span>
      </header>

      <div class="row">
        <!-- Member 1 -->
        <div class="col-lg-6 col-sm-12 mb-sm-50 m-sm-0 text-center">

        </div>
      </div>
    </section>

    <section class="container section team-3col" style="padding-top:20px">
      <header class="sec-heading" style="margin-top:0">
        <h3>When You Become A Partner...</h3>
      </header>

      <div class=" px-4 py-5 md:px-2 lg:px-2">
        <div class="grid">
          <div class="col-12 md:col-6 lg:col-4 p-3">
            <div class="p-3 text-center bg-orange-600" style="border-radius: 12px">
              <span class="inline-flex justify-content-center align-items-center bg-orange-700 border-circle mb-3" style="width:49px; height: 49px">
                <i class="pi pi-shopping-cart text-xl text-white"></i>
              </span>
              <header class="sec-heading" style="margin-top:0">
                <h4 class="text-white mb-2">Product Discounts & Exclusive Products</h4>
              </header>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-4 p-3">
            <div class="p-3 text-center bg-orange-600" style="border-radius: 12px">
              <span class="inline-flex justify-content-center align-items-center bg-orange-700 border-circle mb-3" style="width:49px; height: 49px">
                <i class="pi pi-users text-xl text-white"></i>
              </span>
              <header class="sec-heading" style="margin-top:0">
                <h4 class="text-white mb-2">Exclusive Virtual & Live Event Benefits</h4>
              </header>
              <!--<span class="text-orange-200 font-medium">Check-ins</span>-->
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-4 p-3">
            <div class="p-3 text-center bg-orange-600" style="border-radius: 12px">
              <span class="inline-flex justify-content-center align-items-center bg-orange-700 border-circle mb-3" style="width:49px; height: 49px">
                <i class="pi pi-video text-xl text-white"></i>
              </span>

              <header class="sec-heading" style="margin-top:0">
                <h4 class="text-white mb-2">Exclusive Communal Engagement & More!</h4>
              </header>
              <!--<span class="text-orange-200  font-medium">Files</span>-->
            </div>
          </div>

        </div>
      </div>
    </section>

    <section class="container section team-3col" style="padding-top:20px">
      <header class="sec-heading" style="margin-top:0">
        <h2>Partnership Tiers</h2>
      </header>
      <div class="px-4 py-0 md:px-6 lg:px-8">
        <div class="flex flex-column md:flex-row mt-6">
          <div class="mb-6 md:mb-0 mr-0 md:mr-4 flex flex-column flex-grow-1">
            <div class="bg-bluegray-100 text-center p-3" style="border-radius: 6px 6px 0 0">
              <div class="text-2xl font-bold text-bluegray-900 mb-3">Essential</div>
              <div class="flex align-items-center justify-content-center">
                <span class="font-bold text-bluegray-900 text-5xl mr-2">$50+</span>
                <span class="text-2xl text-bluegray-400"> / month</span>
              </div>
            </div>
            <div class="bg-bluegray-50 p-4 flex flex-column flex-grow-1" style="box-shadow: inset 0px 2px 8px rgba(0, 0, 0, 0.1); border-radius: 0 0 6px 6px">
              <div class="text-bluegray-500  mb-4 sec-heading">Your auto debit of at least $50 or a one time payment of at least $600</div>
              <Button class="p-button w-full mt-auto" label="Join" style="background-color: #f1881a" @click="JoinPartnership('prod_MuFadGEwLEUWri')"></Button>
            </div>
          </div>

          <div class="mb-6 md:mb-0 flex flex-column flex-grow-1 md:mr-4">
            <div class="bg-blue-700 text-center p-3" style="border-radius: 6px 6px 0 0">
              <div class="text-2xl font-bold text-white mb-3">Elite</div>
              <div class="flex align-items-center justify-content-center">
                <span class="font-bold text-white text-5xl mr-2">$100+</span>
                <span class="text-2xl text-blue-400"> / month</span>
              </div>
            </div>
            <div class="bg-blue-800 p-4 flex flex-column flex-grow-1" style="box-shadow: inset 0px 2px 8px rgba(0, 0, 0, 0.1); border-radius: 0 0 6px 6px">
              <div class="text-blue-400 font-bold line-height-3 mb-4">Your auto debit of at least $100 or a one time payment of at least $1200</div>
              <Button class="p-button-outlined w-full mt-auto" label="Join" style="background-color: #f1881a" @click="JoinPartnership('prod_MuFcIDe6b2zTFs')"></Button>
            </div>
          </div>

          <div class="mb-6 md:mb-0 mr-0 flex flex-column flex-grow-1">
            <div class="bg-orange-600 text-center p-3 border-3 border-orange-500 border-bottom-none" style="border-radius: 6px 6px 0 0">
              <div class="text-2xl font-bold text-white mb-3">Elite + VIP </div>
              <div class="flex align-items-center justify-content-center">
                <span class="font-bold text-white text-5xl mr-2">$500+</span>
                <span class="text-2xl text-white"> / month</span>
              </div>
            </div>
            <div class="bg-bluegray-800 p-4 flex flex-column flex-grow-1 border-3 border-bluegray-800 border-top-none" style="box-shadow: inset 0px 2px 8px rgba(0, 0, 0, 0.1); border-radius: 0 0 6px 6px">
              <div class="text-bluegray-400 font-bold line-height-3 mb-4">Your auto debit of at least $500 or a one time payment of at least $6000</div>
              <!--<ul class="list-none p-0 m-0 mb-5 text-bluegray-100">
                <li class="flex align-items-center mb-3">
                  <i class="pi pi-circle-fill mr-2 text-sm"></i>
                  <span>Arcu vitae elementum</span>
                </li>
                <li class="flex align-items-center mb-3">
                  <i class="pi pi-circle-fill mr-2 text-sm"></i>
                  <span>Dui faucibus in ornare</span>
                </li>
                <li class="flex align-items-center mb-3">
                  <i class="pi pi-circle-fill mr-2 text-sm"></i>
                  <span>Morbi tincidunt augue</span>
                </li>
                <li class="flex align-items-center">
                  <i class="pi pi-circle-fill mr-2 text-sm"></i>
                  <span>Duis ultricies lacus sed</span>
                </li>
              </ul>-->

              <Button class="p-button w-full mt-auto" label="Join" @click="JoinPartnership('prod_MuFhtvENLZsV4t')"></Button>
            </div>
          </div>

        </div>
      </div>
      <Divider align="center" class="mt-5">
        <h3 class="my-3"> Make a One Time Donation</h3>
      </Divider>
    </section>

    <section>
      <div class="blog-home2 pb-5 mt-0 pt-0">
        <div class="container">
          <!-- Row  -->
          <div class="row justify-content-center">
            <!-- Column -->
            <!-- Column -->
            <!-- Column -->
          </div>
          <div class="row">
            <!-- Column -->
            <div class="col-md-12 col-sm-12 col-lg-10 mx-auto">
              <div class="row">
                <div class="col-md-6">
                  <label for="FirstName">First Name</label>
                  <InputText type="text" class="p-inputtext-sm w-full" name="FirstName" v-model="donationState.DonationFirstName" @blur="v$.DonationFirstName.$validate()" />
                  <InlineMessage severity="error" v-if="v$.DonationFirstName.$error" class="w-full">{{ v$.DonationFirstName.$errors[0].$message }}</InlineMessage>
                </div>
                <div class="col-md-6 w-full">
                  <label for="LastName">Last Name</label>
                  <InputText type="text" class="p-inputtext-sm w-full" name="LastName" v-model="donationState.DonationLastName" @blur="v$.DonationLastName.$validate()" />
                  <InlineMessage severity="error" v-if="v$.DonationLastName.$error" class="w-full">{{ v$.DonationLastName.$errors[0].$message }}</InlineMessage>
                </div>
              </div>
              <div class="row mt-4 mb-5">
                <div class="col-md-6">
                  <label for="Email">Email</label>
                  <InputText type="text" class="p-inputtext-sm w-full" name="Email" v-model="donationState.DonationEmail" @blur="v$.DonationEmail.$validate()" />
                  <InlineMessage severity="error" v-if="v$.DonationEmail.$error" class="w-full">{{ v$.DonationEmail.$errors[0].$message }}</InlineMessage>
                </div>
                <div class="col-md-6 w-full">
                  <label for="Amount">Donation Amount</label>
                  <InputNumber inputId="currency-us" v-model="donationState.DonationAmount" mode="currency" currency="USD" locale="en-US" class="p-inputtext-sm w-full" @keyup="v$.DonationAmount.$validate()" @keypress="v$.DonationAmount.$validate()" @input="v$.DonationAmount.$validate()" />
                  <InlineMessage severity="error" v-if="v$.DonationAmount.$error" class="w-full">{{ v$.DonationAmount.$errors[0].$message }}</InlineMessage>
                </div>
              </div>
              <div class="row pt-0 m-0">
                <div class="col-md-12 px-0">
                  <Button label="Next" icon="pi pi-arrow-circle-right" class="p-button-outlined w-full m-0" iconPos="right" @click="SetDonationAmount" :disabled="v$.$invalid"></Button>
                </div>
              </div>
              <div class="row mt-5" v-if="ShowDonationForm">
                <div class="col-md-12">
                  <form id="payment-form">
                    <div id="card-element" class="p-inputtext p-component mb-2">
                    </div>
                    <div id="card-errors" role="alert"></div>
                    <Button label="Submit" icon="pi pi-check" iconPos="right" v-on:click="SubmitPayment" :loading="IsSubmittingDonation" :disabled="IsSubmittingDonation" class="w-full w-100" outlined>
                      Submit ${{donationState.DonationAmount}}.00 Donation
                    </Button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  <section id="contactUs">
    <footer class="footer-contact">
      <div class="container-fluid">
        <div class="row">
          <!-- Map and address -->
          <div class="col-lg-6 col-sm-12 no-gap contact-info">
            <!-- Show Info Button -->
            <a href="#" class="show-info-link"><i class="fa fa-info"></i>Show info</a>
            <div id="map-canvas" class="footer-map"></div>
            <address class="contact-info-wrapper">
              <ul>
                <!-- Email -->
                <li class="contact-group">
                  <span class="adr-heading">Email</span>
                  <span class="adr-info">Info@martinwilliams.org</span>
                </li>
              </ul>
              <ul>
                <!-- Mobile -->
                <li class="contact-group">
                  <span class="adr-heading">Phone</span>
                  <span class="adr-info">+1 (531)-329-9985</span>
                </li>
              </ul>
            </address>
          </div><!-- / .col-lg-6 -->
          <!-- Contact Form -->
          <div class="col-lg-6 col-sm-12 no-gap section contact-form" id="App">
            <header class="sec-heading">
              <h2>Connect With Us</h2>
              <span class="subheading">Subscribe or Schedule A Booking</span>
            </header>

            <Accordion :activeIndex="0">
              <AccordionTab>
                <template #header>
                  <i class="fas fa-comment-alt  fa-1x p-1 mr-4 float-left black-text" aria-hidden="true"></i>
                  <h6 class="text-uppercase white-text mb-0 py-3 mt-1">
                    Subscribe To Our Newsletter
                  </h6>
                </template>
                <div class="row mt-4">
                  <!-- Column -->
                  <div class="col-md-12 col-sm-12 col-lg-10 mx-auto">
                    <div class="row">
                      <div class="col-md-12">
                        <label for="FirstName">First Name</label>
                        <InputText type="text" class="p-inputtext-sm w-full" name="FirstName" v-model="subscriptionState.FirstName" @blur="s$.FirstName.$validate()" />
                        <InlineMessage severity="error" v-if="s$.FirstName.$error" class="w-full">{{ s$.FirstName.$errors[0].$message }}</InlineMessage>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-md-12 w-full">
                        <label for="LastName">Last Name</label>
                        <InputText type="text" class="p-inputtext-sm w-full" name="LastName" v-model="subscriptionState.LastName" @blur="s$.LastName.$validate()" />
                        <InlineMessage severity="error" v-if="s$.LastName.$error" class="w-full">{{ s$.LastName.$errors[0].$message }}</InlineMessage>
                      </div>
                    </div>
                    <div class="row mt-2 mb-2">
                      <div class="col-md-12">
                        <label for="Email">Email</label>
                        <InputText type="text" class="p-inputtext-sm w-full" name="Email" v-model="subscriptionState.Email" @blur="s$.Email.$validate()" />
                        <InlineMessage severity="error" v-if="s$.Email.$error" class="w-full">{{ s$.Email.$errors[0].$message }}</InlineMessage>
                      </div>
                    </div>
                    <div class="row mt-2 mb-2 flex justify-content-end">
                      <div class="col-md-12 flex justify-content-end">
                        <Button label="Subscribe" icon="pi pi-arrow-circle-right" :loading="IsSubscribing" class="p-button-outlined mt-2" iconPos="right" @click="Subscribe" :disabled="s$.$invalid"></Button>
                      </div>
                    </div>
                  </div>
                </div>
              </AccordionTab>
              <AccordionTab>
                <template #header>
                  <i class="fas fa-microphone-alt  fa-1x p-1 mr-4 float-left black-text" aria-hidden="true"></i>
                  <h6 class="text-uppercase white-text mb-0 py-3 mt-1">
                    Book Dr. Martin Williams
                  </h6>
                </template>
                <div class="row mt-4">
                  <!-- Column -->
                  <div class="col-md-12 col-sm-12 col-lg-10 mx-auto">
                    <div class="row">
                      <div class="col-md-12">
                        <label for="FirstName">Contact Name</label>
                        <InputText type="text" class="p-inputtext-sm w-full" name="FirstName" v-model="bookingState.ContactName" @blur="b$.ContactName.$validate()" />
                        <InlineMessage severity="error" v-if="b$.ContactName.$error" class="w-full">{{ b$.ContactName.$errors[0].$message }}</InlineMessage>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-md-12 w-full">
                        <label for="LastName">Organization Name</label>
                        <InputText type="text" class="p-inputtext-sm w-full" name="LastName" v-model="bookingState.OrganizationName" @blur="b$.OrganizationName.$validate()" />
                        <InlineMessage severity="error" v-if="b$.OrganizationName.$error" class="w-full">{{ b$.OrganizationName.$errors[0].$message }}</InlineMessage>
                      </div>
                    </div>
                    <div class="row mt-2 mb-2">
                      <div class="col-md-12">
                        <label for="Email">Phone #</label>
                        <InputText type="text" class="p-inputtext-sm w-full" name="Email" v-model="bookingState.PhoneNumber" @blur="b$.PhoneNumber.$validate()" />
                        <InlineMessage severity="error" v-if="b$.PhoneNumber.$error" class="w-full">{{ b$.PhoneNumber.$errors[0].$message }}</InlineMessage>
                      </div>
                    </div>

                    <div class="row mt-2 mb-2">
                      <div class="col-md-12">
                        <label for="Email">Email</label>
                        <InputText type="text" class="p-inputtext-sm w-full" name="Email" v-model="bookingState.Email" @blur="b$.Email.$validate()" />
                        <InlineMessage severity="error" v-if="b$.Email.$error" class="w-full">{{ b$.Email.$errors[0].$message }}</InlineMessage>
                      </div>
                    </div>

                    <div class="row mt-2 mb-2">
                      <div class="col-md-12">
                        <label for="Email">Event Date</label>
                        <!--<Calendar v-model="bookingState.EventDate" selectionMode="single" @blur="b$.EventDate.$validate()" />-->
                        <InlineMessage severity="error" v-if="b$.EventDate.$error" class="w-full">{{ b$.EventDate.$errors[0].$message }}</InlineMessage>
                      </div>
                    </div>

                    <div class="row mt-2 mb-2">
                      <div class="col-md-12">
                        <label for="EventDetails">Event Details</label>
                        <Textarea v-model="bookingState.EventDescription" :autoResize="true" rows="5" cols="30" class="w-full" name="EventDetails" @blur="b$.EventDescription.$validate()" />
                        <InlineMessage severity="error" v-if="b$.EventDescription.$error" class="w-full">{{ b$.EventDescription.$errors[0].$message }}</InlineMessage>
                      </div>
                    </div>

                    <div class="row mt-2 mb-2 flex justify-content-end">
                      <div class="col-md-12 flex justify-content-end">
                        <Button label="Complete Booking" icon="pi pi-arrow-circle-right" :loading="IsBooking" class="p-button-outlined mt-2" iconPos="right" @click="SubmitEventRequest" :disabled="b$.$invalid"></Button>
                      </div>
                    </div>
                  </div>
                </div>
              </AccordionTab>
            </Accordion>
          </div><!-- / .col-lg-6 -->
        </div><!-- / .row -->
      </div><!-- / .container-fluid -->
      <!-- Social Links -->
      <div class="modal fade" id="centralModalInfo" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
           aria-hidden="true">
        <div class="modal-dialog modal-notify modal-info" role="document">
          <!--Content-->
          <div class="modal-content">
            <!--Header-->
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" class="white-text">&times;</span>
              </button>
            </div>
            <!--Body-->
            <div class="modal-body">
              <div class="text-center">
                <img class="d-flex mr-3 animated rotateIn img-fluid" src="/images/legofw.jpg" alt="Generic placeholder image">
                <p>
                  <b>
                    Our mission is to serve church leaders by providing distinguished, customized services that will elevate the systems, understanding, and operations or each organization through clear directions and trusted industry standards.
                  </b>
                </p>
              </div>
            </div>
            <!--Footer-->
            <div class="modal-footer justify-content-end">
              <a type="button" class="btn btn-sm close" style="background-color: #f18c18" data-dismiss="modal">Close</a>
            </div>
          </div>
          <!--/.Content-->
        </div>
      </div>

      <div class="modal fade" id="centralModalDark" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
           aria-hidden="true">
        <div class="modal-dialog modal-notify modal-dark" role="document">
          <!--Content-->
          <div class="modal-content">
            <!--Header-->
            <div class="modal-header" style="background-color:black">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" class="white-text">&times;</span>
              </button>
            </div>
            <!--Body-->
            <div class="modal-body">
              <div class="text-center">
                <img class="d-flex mr-3 animated rotateIn img-fluid" src="/images/legacyofwealth.jpg" alt="Generic placeholder image">
                <p>
                  <b>
                    Our philosophy is to understand and apply Kingdom principles to accomplish sustainable wealth. We believe that by having intentional conversations we can access the place where your life, morals, and values intersect with financial aspirations. We are committed to the belief that wealth is more than numbers, most important is the legacy you leave for your loved ones.
                  </b>
                </p>
              </div>
            </div>
            <!--Footer-->
            <div class="modal-footer justify-content-end">
              <a type="button" class="btn btn-sm close" style="background-color: #f18c18" data-dismiss="modal">Close</a>
            </div>
          </div>
          <!--/.Content-->
        </div>
      </div>

      <div class="dark-bg">
        <div class="container footer-social-links">
          <div class="row">
            <ul>
              <li><a href="https://www.facebook.com/MartinWilliamsInternational"><i class="fa-brands fa fa-facebook"></i></a></li>
              <li><a href="https://www.instagram.com/MartinWilliamsIntl"><i class="fa-brands fa fa-instagram"></i></a></li>
              <li><a href="https://www.youtube.com/c/MartinWilliams"><i class="fa-brands fa fa-youtube"></i></a></li>
              <li><a href="https://www.twitter.com/DrMartinW"><i class="fa-brands fa fa-twitter"></i></a></li>
              <li><a href="https://www.linkedin.com/in/martin-williams-673ab8128/"><i class="fa-brands fa fa-linkedin"></i></a></li>
            </ul>
          </div>
        </div><!-- / .container -->
      </div><!-- / .dark-bg -->
      <!-- Copyright -->
      <div class="copyright">
        <div class="container">
          <div class="row">

            <div class="col-md-6">
              <small>&copy; 2021 Martin Williams International. All Rights Reserved.</small>
            </div>

            <div class="col-md-6">
              <small><a href="#app " class="pull-right to-the-top scroll">To the top<i class="fa fa-angle-up scroll"></i></a></small>
            </div>

          </div><!-- / .row -->
        </div><!-- / .container -->
      </div><!-- / .copyright -->
    </footer><!-- / .footer-contact -->
  </section>
  <Toast />
</template>

<style scoped>

  .navbar-brand {
    float: none;
    font-size: 18px;
    line-height: 20px;
    max-height: 60px;
  }

  .p-button {
    color: #ffffff;
    background: #ff9800;
    border: 1px solid #ff9800;
    padding: 0.75rem 1.25rem;
    font-size: 1rem;
    transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
    border-radius: 6px;
  }

    .p-button:hover {
      color: white;
      background: lightgrey;
      border: 1px solid lightgrey;
      border-radius: 6px;
    }

  ul.stepper .step.active:before {
    background-color: #ff9800 !important;
  }

  .modal-dialog-full-width {
    width: 100% !important;
    height: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    max-width: none !important;
  }

  .modal-content-full-width {
    height: auto !important;
    min-height: 100% !important;
    border-radius: 0 !important;
    background-color: #ececec !important;
  }

  .modal-header-full-width {
    border-bottom: 1px solid #9ea2a2 !important;
  }

  .modal-footer-full-width {
    border-top: 1px solid #9ea2a2 !important;
  }

  .sec-heading {
    margin-bottom: 25px !important;
  }

  .section {
    padding-top: 160px;
    padding-bottom: 25px !important;
  }

  .pricing-table .card {
    transition: all 0.2s;
    border-radius: 15px;
  }

    .pricing-table .card .card-title {
      font-size: 1rem;
      letter-spacing: .2rem;
      font-weight: 500;
    }

    .pricing-table .card .card-price {
      font-size: 2.7rem;
    }

      .pricing-table .card .card-price .term {
        font-size: .875rem;
      }

    .pricing-table .card .fa-ul li:not(:last-child) {
      margin-bottom: 1rem;
    }

  @media (min-width: 992px) {
    .pricing-table .card:hover {
      margin-top: -.25rem;
      margin-bottom: .25rem;
      box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.3);
    }
  }
</style>

<script>

  


  import { reactive, computed } from 'vue'
  import InputNumber from 'primevue/inputnumber';
  import InlineMessage from 'primevue/inlinemessage';
  import { loadStripe } from '@stripe/stripe-js';
  import useVuelidate from '@vuelidate/core'
  import Toast from 'primevue/toast';
  import { required, email, helpers, minValue } from '@vuelidate/validators'
  /*import Badge from 'primevue/badge';*/
  import Divider from 'primevue/divider';
/*  import Card from 'primevue/card'*/
/*  import Timeline from 'primevue/timeline';*/
  import Button from 'primevue/button';
  import InputText from 'primevue/inputtext';
  import Textarea from 'primevue/textarea';
  import Accordion from 'primevue/accordion';
  import AccordionTab from 'primevue/accordiontab';
/*  import Calendar from 'primevue/calendar';*/
  import $ from 'jquery'

    export default {
    name: 'HomePage',
    components: {
      //Badge,
      //Timeline,
      //Card,
      Divider,
      InlineMessage,
      Button,
      Toast,
/*      Calendar,*/
      InputNumber,
      InputText,
      Accordion,
      Textarea,
      AccordionTab
    },
        data() {
            return {
              BtnText: 'Send',
              IsSubmitting: false,
              ShowDonationForm: false,
              IsSubscribing: false,
              IsBooking: false,
              IsSubmittingDonation: false,
              events1: [
                {
                  status: 'Take The Power Tools Assessment', Summary: "During this assessment, you'll review multiple questions or statements, you choose which ones best aligns with you.", icon: 'fa fa-solid fa-book fa-xl', color: '#FFB74D' },
                { status: 'Get Your Tailored Results', Summary: "Review your Power Cluster of strengths in your report and experience how to better identify and utilize your strengths in many facets of your life.", icon: 'pi pi-chart-line', color: '#FB8C00' },
                { status: 'Utilize Your Power Cluster', Summary: 'Take the knowledge of your strengths and apply them in confidence in every part of your life, and win!', icon: 'pi pi-bolt', color: '#EF6C00' },
              ],
                EmailAddress:'',
                DonationAmount:20,
                Stripe: '',
                Card: '',
                Elements:''
            }
    },
    setup() {
            const donationState = reactive({
              EmailAddress: '',
                DonationFirstName: '',
                DonationLastName: '',
                DonationEmail: '',
                DonationAmount: null,
            })

            const subscriptionState = reactive({
              EmailAddress: '',
              FirstName: '',
              LastName: '',
            })

           const bookingState = reactive({
               ContactName: '',
               OrganizationName: '',
               PhoneNumber: '',
               EventDate: '',
               Email: '',
               EventDescription: '',
               TemplateType: 'BookingRequest',
             })

           const bookingRules = computed(() => {
              return {
                ContactName: { required: helpers.withMessage("Please enter a contact name", required) },
                OrganizationName: { required: helpers.withMessage("Please enter a organization name", required)},
                Email: { required: helpers.withMessage("Please enter your email", required), email: helpers.withMessage("Please enter a valid email address", email) },
                PhoneNumber: { required: helpers.withMessage("Please enter a phone #", required) },
                EventDate: { required: helpers.withMessage("Please select a event date", required) },
                EventDescription: { required: helpers.withMessage("Please enter a event description", required) }
              }
            });

           const donationRules = computed(() => {
                return {
                  DonationFirstName: { required: helpers.withMessage("Please enter your first name", required) },
                  DonationLastName: { required: helpers.withMessage("Please enter your last name", required) },
                  DonationEmail: { required: helpers.withMessage("Please enter your email", required), email: helpers.withMessage("Please enter a valid email address", email) },
                  DonationAmount: {
                    required: helpers.withMessage("Please specify a donation amount", required), minValue:  helpers.withMessage("Amount must be at least $10.00", minValue(10)) },
                }
            });

           const subscriptionRules = computed(() => {
             return {
               FirstName: { required: helpers.withMessage("Please enter your first name", required) },
               LastName: { required: helpers.withMessage("Please enter your last name", required) },
               Email: { required: helpers.withMessage("Please enter your email", required), email: helpers.withMessage("Please enter a valid email address", email) },
             }
           });

            const b$ = useVuelidate(bookingRules, bookingState)
            const s$ = useVuelidate(subscriptionRules, subscriptionState)
            const v$ = useVuelidate(donationRules, donationState)

      return {
        donationState, v$, subscriptionState, subscriptionRules, s$, b$, bookingRules, bookingState,
      }
     },
        
        //components: {
        //    ValidationObserver,
        //    ValidationProvider
        //},
    created() {
      this.$emit("set-nav", this.$route)
     
    },
        mounted() {

            const plugin = document.createElement("script");
            plugin.setAttribute(
                "src",
                "/js/main.js"
            );
            plugin.async = true;
           document.head.appendChild(plugin);

          setTimeout(() => {
            $('.preloader img').fadeOut(); // will first fade out the loading animation
            $('.preloader').delay(400).fadeOut('slow', function () {
            });



          }, 900)

        },
        methods: {
          JoinPartnership(partnershipId) {
            this.$router.push({ path: "/SignUpStepOne", query: { ProductId: partnershipId } })
          },
          async LoadStripe() {

              var self = this;
              self.ShowDonationForm = true;
                const stripe = await loadStripe('pk_live_51L5XlRDvrfFo4D7XXPNf8AObpvaiB0yzzYf9BuWjuUcUFzoGuR6NCmLXxYetpthzLI6XzkefoWZ6Ym556SyzrZmu00vyGo3nMq');
                this.Stripe = stripe;
                await this.$http.post('/Payments/CreateIntent',
                    { Amount: self.donationState.DonationAmount, DevMode: 1000}).then(function (response) {
                        if (response.data.success) {
                           
                            const elements = stripe.elements({ clientSecret: response.data.paymentIntent.client_secret });
                            var card = elements.create("card");
                            self.Elements = card;

                            var style = {
                                base: {
                                    color: "#32325d",
                                }
                            };

                            // Stripe injects an iframe into the DOM
                            card.mount("#card-element", { style: style });
                            self.Card = card;

                            card.on('change', ({ error }) => {
                                let displayError = document.getElementById('card-errors');
                                if (error) {
                                    displayError.textContent = error.message;
                                } else {
                                    displayError.textContent = '';
                                }
                            });
                        }
                    })
               
            },
          async SetDonationAmount() {
            var validateAmount = await this.v$.DonationAmount.$validate()
            if (validateAmount) {
              this.LoadStripe();
            }
           },
          Login: function () {

            this.$router.push({ name: 'LoginHome' });
          },
          BeginAssessment() {
            this.$router.push({ name: 'TakeAssessment', params: { AssessmentType: 1000, AssessmentId: 32 } })
          },
          FindAssessment() {
            this.$router.push({ path: '/LocateAssessment'})
          },
          PurchaseAssessment() {
            window.location.href = "https://link.fastpaydirect.com/payment-link/66e4d2e80adb9fc58cb50226";
          },
        async Subscribe () {

          var self = this;
          self.IsSubscribing;

          await this.$http.post('/Authorization/NewUserSignUp',
            {
              FirstName: self.subscriptionState.FirstName,
              LastName: self.subscriptionState.LastName,
              Email: self.subscriptionState.Email,
              UserName: self.subscriptionState.Email,
              Password: null,
              RoleId: 'NEWL',
            }).then(function (response) {

              if (response.data.success) {
                self.$toast.add({ severity: 'success', summary: 'Success', detail: 'Successfully Subscribed', life: 3000 });

              }
              else {
                self.IsSubscribing = false;
                self.BtnText = 'Sign Up'
                self.$toast.add({ severity: 'error', summary: 'Error', detail: 'Error Subscribing', life: 3000 });
              }
            })


         },
         async SubmitPayment() {
                var self = this;
               self.IsSubmittingDonation = true;
               var paymentToken;
               var hasError = false;

               await self.Stripe.createToken(self.Card).then(function (result) {
                    if (result.error) {
                        hasError = true;
                        // Inform the customer that there was an error.
                        var errorElement = document.getElementById('card-errors');
                        errorElement.textContent = result.error.message;
                        self.IsSubmittingDonation = false;
                    } else {
                        paymentToken = result.token;
                    }
                });

               if (!hasError) {
                   console.log(paymentToken)
                 await this.$http.post('/Payments/SubmitPayment', {
                   Amount: self.donationState.DonationAmount,
                   Token: paymentToken.id,
                   FirstName: self.donationState.DonationFirstName,
                   LastName: self.donationState.DonationLastName,
                   Email: self.donationState.DonationEmail,
                   DevMode: 1000
                 }
                   )
                       .then(function (response) {
                           if (response.data.success) {
                               /* toastr.success('Your message was sent successfully');*/
                             self.IsSubmittingDonation = false;
                             self.$toast.add({ severity: 'success', summary: 'Success', detail: 'Donation Successful', life: 3000 });
                               self.Elements.clear();
                             self.v$.$reset();
                             self.ShowDonationForm = false;
                             self.donationState.DonationFirstName = null;
                             self.donationState.DonationLastName = null;
                             self.donationState.DonationEmail = null;
                             self.donationState.DonationAmount = null;

                           }
                           else {
                               self.IsSubmittingDonation = false;
                               self.Elements.clear();
                               self.$toast.add({ severity: 'error', summary: 'Error', detail: 'Error Submitting Payment', life: 3000 });
                           }
                       })
                       .catch(function (error) {
                           console.log(error);
                           self.IsSubmittingDonation = false;
                           self.Elements.clear();
                           self.$toast.add({ severity: 'error', summary: 'Error', detail: 'Error Submitting Payment', life: 3000 });
                       });

               }
            },
            async SubmitEventRequest() {
              
                    this.IsBooking = true
                    var self = this;
                    var bookingForm = self.bookingState;

                    await this.$http.post('/Templates/SendTemplateResponse',
                        bookingForm, {
                        headers: {
                            "Access-Control-Allow-Origin": "*",
                            'content-type': 'text/json'
                        }
                    })
                        .then(function (response) {
                            if (response.data.success) {
                              self.$toast.add({ severity: 'success', summary: 'Success', detail: 'Booking Request Successful', life: 3000 });
                              self.IsBooking = false;
                              self.BtnText = "Send"
                              self.b$.$reset();
                          }
                          else{
                              self.$toast.add({ severity: 'error', summary: 'Error', detail: 'Error Sending Booking Request', life: 3000 });
                              self.IsBooking = false;
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                
            },
        }
    }
</script>